<template>
  <div class="xscontainer jsjiesh">
    <div class="shang">
      <div>
        <el-page-header @back="goBack" content="方案推荐">
        </el-page-header>
      </div>
      <div class="left1123">
        <div class="contentcss">
          <p class="btcss">{{currentZhishi.biaoti}}</p>
          <div class="cot" v-html="currentZhishi.neirong"></div>
        </div>
<!--        <div class="fenye" style="justify-content: center">-->
<!--          <div class="fybtn">上一篇</div>-->
<!--          <div class="fybtn">下一篇</div>-->
<!--        </div>-->

        <div class="hhhksee">
          <!--          <p>我的链接：{{ link }}</p>-->
          <el-button type="info" round @click="copyLink">复制链接分享给更多人</el-button>
          <p v-if="copied" class="success">链接已复制！</p>
        </div>
      </div>
    </div>
    <div class="dsfsdfg" v-model="fwcishu">【访问次数:{{fwcishu}}】</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentZhishi:{},
      fwcishu:0
    };
  },
  mounted() {
    debugger
    var params = this.$route.query;
    let id = params.id;
    this.queryShishixiangqing(id);
  },
  created() {
    var params = this.$route.query;
    let id = params.id;
    this.tongji("fanan="+id);
  },
  methods:{
    tongji(caidan) {
      var that = this;
      this.$ajax
          .post(this.GLOBAL.sys_addr + '/tongji/tTongji/tj', {caidan: caidan})
          .then(function (response) {
            if (response.status == 200) {
              that.fwcishu = response.data;
            }
          });
    },
    copyLink() {
      const el = document.createElement('textarea')
      el.value = window.location.href;
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)

      this.copied = true
      setTimeout(() => {
        this.copied = false
      }, 2000)
    },
    goBack(){
      this.$router.back()
    },
    queryShishixiangqing(id){
      var that = this;
      this.$ajax
          .get(this.GLOBAL.sys_addr + '/shishi/tShishifangan/list?_t='+new Date().getTime()+'&column=id&order=asc&pageNo='+0+'&pageSize='+1+"&id="+id)
          .then(function (response) {
            if (response.data.code == 200) {
              that.currentZhishi  = response.data.result.records[0];
            } else {
              that.$notify.warning({ position: 'bottom-right', title: '提示', message: response.data.msg });
            }
          });
    },
  }
};
</script>

<style scoped>
.jsjiesh{
  width: 60%;
  display: flex;
  gap: 1rem;
  align-items: start;
  flex-direction: column;
}
.shang{
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
.left1123{
  width:100%;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
.right{
  width:20%;
  display: flex;
  flex-direction: column;
  gap: 1rem;

}
.tabcss{
  width: 70%;
  display: flex;
  justify-content: start;
}
.linkcs{
  width: 33.33%;
  font-size: 1rem;
  color: #8a8a8a;
}
.linkcs:hover{
  color: #46abf5;
  cursor: pointer;
}
.btcss{
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 1.5rem;
  margin-top: 1.5rem;
}
.contentcss{
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.cot{
  letter-spacing: 1.5px;
  line-height: 32px;
}
.upcs{
  width: 100%;
  height: 8rem;
  background: -webkit-linear-gradient(bottom, #fff, #1e5de9);
  background: -moz-linear-gradient(bottom, #fff, #1e5de9);
  background: linear-gradient(to top, #fff, #1e5de9);
  display: flex;
  align-items: end;
}
.upin{
  width: 100%;
  height: 2rem;
  background-color: #373636;
  opacity: 0.5;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.dowcs{
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 2rem;
}
.mitm{
  height: 7%;
  text-align: left;
  padding-left1123: 20px;
  width: 100%;
  border:1px solid #a4a2a2;
  display: flex;
  justify-content: center;
  align-items: center;
}
.mitm:hover{
  border:1px solid #dce6ee;
  cursor: pointer;
  background-color: #46abf5;
  color: #ffffff;
}

</style>
